import { PropertyImage } from "../../data"
import { getProxiedImageUrl } from "../../../../common/image-proxy"

export default function TwoRowThreeImageGrid({ images, startIndex = 0, onClick, containerWidth = 700 }: {
    images: PropertyImage[]
    startIndex?: number
    onClick?: (imageIndex: number) => void
    containerWidth?: number
}) {
    // Don't render if we don't have enough images (need at least 1, max 3)
    if (images.length === 0) {
        return null
    }

    // Take only the first 3 images
    const displayImages = images.slice(0, 3)
    const [firstImage, ...remainingImages] = displayImages

    return (
        <div className="homerunner-gallery-two-row-three-grid-container mb-2">
            <div className="homerunner-gallery-two-row-three-grid flex flex-col gap-2" style={{ maxWidth: containerWidth + 'px', margin: '0 auto' }}>
                {/* First row - Single full-width image */}
                <div className="homerunner-gallery-two-row-three-main-image gallery-image-container aspect-[16/9]">
                    <button
                        type="button"
                        className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                        data-global-index={startIndex}
                        onClick={() => onClick?.(startIndex)}
                    >
                        <img
                            src={getProxiedImageUrl(firstImage.url, 700, 394)}
                            alt={firstImage.caption || `Property image ${firstImage.position}`}
                            className="homerunner-gallery-image"
                        />
                        {/* Hover overlay */}
                        <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
                    </button>
                </div>

                {/* Second row - Two images equally divided */}
                {remainingImages.length > 0 && (
                    <div className="homerunner-gallery-two-row-three-thumbnails grid grid-cols-2 gap-2">
                        {remainingImages.map((image, localIndex) => (
                            <div key={localIndex} className="homerunner-gallery-two-row-three-thumbnail gallery-image-container aspect-[16/9]">
                                <button
                                    type="button"
                                    className="appearance-none border-0 bg-transparent p-0 m-0 block w-full h-full text-left cursor-pointer"
                                    data-global-index={startIndex + 1 + localIndex}
                                    onClick={() => onClick?.(startIndex + 1 + localIndex)}
                                >
                                    <img
                                        src={getProxiedImageUrl(image.url, 350, 197)}
                                        alt={image.caption || `Property image ${image.position}`}
                                        className="homerunner-gallery-image"
                                    />
                                    {/* Hover overlay */}
                                    <div className="homerunner-gallery-hover-overlay gallery-hover-overlay"></div>
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
